import type { DayLog, KayaState } from "../domain/types";

/** The day's log, created empty on first touch. For use inside `update()` drafts only: it
 *  mutates. Every writer that logs against a day goes through here so the shape of a fresh day
 *  is decided once. */
export function touchDay(d: KayaState, ds: string): DayLog {
  if (!d.logs[ds]) d.logs[ds] = { done: {}, treadmill: null };
  return d.logs[ds];
}
